import { useState, useEffect, useCallback } from 'react';

const useOtpTimer = (initialTime: number) => {
  const [seconds, setSeconds] = useState(initialTime);
  let lastTime = Date.now();

  useEffect(() => {
    let interval: any;

    const handleVisibilityChange = () => {
      if (document.hidden) {
        clearInterval(interval);
      } else {
        const now = Date.now();
        const elapsed = Math.floor((now - lastTime) / 1000);
        setSeconds((prevSeconds) => Math.max(prevSeconds - elapsed, 0));
        lastTime = now;
        interval = setInterval(() => {
          setSeconds((prevSeconds) => (prevSeconds > 0 ? prevSeconds - 1 : 0));
        }, 1000);
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    if (!document.hidden) {
      interval = setInterval(() => {
        setSeconds((prevSeconds) => (prevSeconds > 0 ? prevSeconds - 1 : 0));
      }, 1000);
    }

    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [seconds]);

  const resetTimer = useCallback(() => {
    setSeconds(initialTime);
    lastTime = Date.now();
  }, [initialTime]);

  return { seconds, resetTimer };
};

export default useOtpTimer;
